import * as ReactDOM from "react-dom";
import * as React from "react";

import { library } from "@fortawesome/fontawesome-svg-core";
import { fad } from "@fortawesome/pro-duotone-svg-icons";

import "react-loading-skeleton/dist/skeleton.css";
import "./fonts.css";
// import "react-big-calendar/lib/sass/styles.scss";

import App from "./App";

library.add(fad);

ReactDOM.render(<App />, document.getElementById("app"));
